import moment from "moment";
import { ContractReportQueryDto } from "../../../autogen/bff-api";

interface BuildStatusFiltersInput {
  base: Partial<ContractReportQueryDto>;
  useLimitZero?: boolean;
}

const withCommonResets = (base: Partial<ContractReportQueryDto>): Partial<ContractReportQueryDto> => ({
  ...base,
  statuses: undefined,
  startDateFrom: undefined,
  startDateTo: undefined,
  endDateFrom: undefined,
  endDateTo: undefined,
  terminationDateFrom: undefined,
  terminationDateTo: undefined,
  hasNoEndDate: undefined,
});

const maybeWithLimitZero = (
  q: Partial<ContractReportQueryDto>,
  useLimitZero?: boolean
): Partial<ContractReportQueryDto> => (useLimitZero ? { ...q, limit: 0 } : q);

export const buildAwardedFilters = ({
  base,
  useLimitZero,
}: BuildStatusFiltersInput): Partial<ContractReportQueryDto> => {
  const today = moment().startOf("day");
  const q: Partial<ContractReportQueryDto> = {
    ...withCommonResets(base),
    startDateFrom: today.clone().add(1, "day").format("YYYY-MM-DD"),
  };
  return maybeWithLimitZero(q, useLimitZero);
};

export const buildActiveFilters = ({
  base,
  useLimitZero,
}: BuildStatusFiltersInput): Partial<ContractReportQueryDto> => {
  const today = moment().startOf("day");
  const todayStr = today.format("YYYY-MM-DD");
  const q: Partial<ContractReportQueryDto> = {
    ...withCommonResets(base),
    startDateTo: todayStr,
    endDateFrom: todayStr,
    terminationDateFrom: todayStr,
  };
  return maybeWithLimitZero(q, useLimitZero);
};

export const buildExpiredFilters = ({
  base,
  useLimitZero,
}: BuildStatusFiltersInput): Partial<ContractReportQueryDto> => {
  const today = moment().startOf("day");
  const q: Partial<ContractReportQueryDto> = {
    ...withCommonResets(base),
    endDateTo: today.clone().subtract(1, "day").format("YYYY-MM-DD"),
  };
  return maybeWithLimitZero(q, useLimitZero);
};

export const buildExpiringThisYearFilters = ({
  base,
  useLimitZero,
}: BuildStatusFiltersInput): Partial<ContractReportQueryDto> => {
  const today = moment().startOf("day");
  const q: Partial<ContractReportQueryDto> = {
    ...withCommonResets(base),
    endDateFrom: today.clone().format("YYYY-MM-DD"),
    endDateTo: today.clone().endOf("year").format("YYYY-MM-DD"),
  };
  return maybeWithLimitZero(q, useLimitZero);
};

export const buildTerminatedFilters = ({
  base,
  useLimitZero,
}: BuildStatusFiltersInput): Partial<ContractReportQueryDto> => {
  const today = moment().startOf("day");
  const q: Partial<ContractReportQueryDto> = {
    ...withCommonResets(base),
    terminationDateTo: today.format("YYYY-MM-DD"),
  };
  return maybeWithLimitZero(q, useLimitZero);
};
